export enum AppName {
  CUSTOMER_PLATFORM = 'wm-front',
  ADMIN_PLATFORM = 'wm-admin',
  REPORTS = 'wm-reports',
}
